import React from 'react';
import { Menu, MenuScroll } from './styles';
import MenuButton from './MenuButton';

export default function MenuLista({
  desktop,
  right,
  setComponentPath,
  currentModulo,
  currentMenu,
  currentSubMenu,
  showMaxMenu,
  showSubMenu,
  setShowSubMenu,
  showMenuWithSubMenu,
  setShowMenuWithSubMenu,
  hasUnreadComunicados,
}) {
  return (
    <Menu {...{ desktop, showMaxMenu }}>
      <div className="menu-scroll">
        {currentModulo?.menus &&
          currentModulo?.menus.map(
            (menu, mi) =>
              menu?.subMenus &&
              ((right && mi > 7) || (!right && mi < 8)) && (
                <div className="menu-button" key={menu.id || mi}>
                  <MenuButton
                    {...{
                      desktop,
                      menu,
                      selected: currentMenu?.id === menu?.id,
                      setComponentPath,
                      showSubMenu,
                      setShowSubMenu,
                      currentModulo,
                      currentSubMenu,
                      showMenuWithSubMenu,
                      setShowMenuWithSubMenu,
                      hasUnreadComunicados,
                    }}
                  />
                </div>
              ),
          )}
      </div>
    </Menu>
  );
}
